import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import {
  ReportDesignerItemTitle,
  ReportDesignItemTitleConfig
} from "../../report-design-item";

@Component({
  selector: "snt-report-designer-title",
  templateUrl: "report-designer-title.component.html",
  styles: [
    `
      :host {
        display: flex;
        flex: 1;
      }
    `
  ],
  standalone: false
})
export class ReportDesignerTitleComponent implements OnInit {
  @Input()
  item!: ReportDesignerItemTitle;

  @Input()
  level!: number;

  @Input()
  parentName!: string;

  @Input()
  readonly: boolean = false;

  @Output() config: EventEmitter<ReportDesignItemTitleConfig> =
    new EventEmitter();

  formData: {
    title: string | undefined;
    size: string | undefined;
    alignment: string | undefined;
    fontWeight: string | undefined;
  } = {
    title: undefined,
    size: undefined,
    alignment: undefined,
    fontWeight: undefined
  };

  ngOnInit(): void {
    this.formData.title = this.item.config.title || undefined;
    this.formData.size = this.item.config.size || undefined;
    this.formData.alignment = this.item.config.alignment || "left";
    this.formData.fontWeight = this.item.config.fontWeight || "normal";
  }

  onFieldDataChanged(): void {
    this.config.emit(this.formData);
  }

  async renderPdfObject(): Promise<Record<string, any>> {
    return {
      type: "title",
      titleValue: this.formData.title,
      size: this.formData.size,
      alignment: this.formData.alignment,
      fontWeight: this.formData.fontWeight
    };
  }
}
